import mixitup from 'mixitup'; // loaded from node_modules
import mixitupMultifilter from '../vendor/mixitup-multifilter'; // loaded from a directory of your choice within your project

// // Call the mixitup factory's .use() method, passing in the extension to install it
mixitup.use(mixitupMultifilter);

let mixer;

const setProjectFilter = () => {

  let projectFilter = function (element, initialFilter) {
    this.filters = Array.from(document.querySelectorAll('[data-filter]'));
    this.initialFilter = initialFilter;
    this.element = element;   

    mixer = mixitup(element, {
        selectors: {
          control: '[data-mixitup-control]'
        },
        load: {
          filter: initialFilter,
        },
        multifilter: {
            enable: true // enable the multifilter extension for the mixer
        },
        animation: {
            "duration": 250,
            "nudge": true,
            "effects": "fade scale(0.75) translateZ(-100px) stagger(0ms)"
        },
        callbacks: {
          onMixStart: handleToggleFilters
        }
    });

    this._bindEventListeners();

  };

  /**
   * Bind event listeners for when the filters change.
   */
  projectFilter.prototype._bindEventListeners = function () {

    this._onButtonChange = this._handleButtonChange.bind(this);
    this._updateFilterParent = this.handleFilters.bind(this);

    this.filters.forEach(function (button) {
      button.addEventListener('click', this._onButtonChange);
    }, this);

    /**
     * listeners for setting active state on parent.
     */

    let filterButtons = document.querySelectorAll('[data-filter]')

    filterButtons.forEach(function (button) {
      button.addEventListener('click', this._updateFilterParent)
    }, this); 


  };  

  /**
   * A button was clicked. Update filters and display.
   * @param {Event} evt Click event object.
   */
  projectFilter.prototype._handleButtonChange = function (evt) {
    let button = evt.currentTarget;
    let activeFilter = button.getAttribute('data-filter');

    // If the button is already active, reset the state of the filters.
    if (button.classList.contains('mixitup-control-active')) {

      if (button.getAttribute('type') == "reset") {
        button.setAttribute('type', 'button');
      } else {
        button.setAttribute('type', 'reset');
      }

    } else {

      if (button.getAttribute('type') == "reset" && (!button.classList.contains('btn-reset')) ) {
        button.setAttribute('type', 'button');
      } 

    }

  };  

  /**
   * A button was clicked. Update activeState on parentNode.
   * @param {Event} evt Click event object.
   */
  projectFilter.prototype.handleFilters = function (evt) {
    let button = evt.currentTarget;
    let filterGroup = button.parentNode

    // if button is 1st column (data-filter)
    if (button.hasAttribute('data-filter')) {

      if (button.getAttribute('type') != "reset") {
        filterGroup.classList.add('filter-group-active');
      }

      if (button.getAttribute('type') == "reset") {
        filterGroup.classList.remove('filter-group-active');
      }

    }

  };  


  /**
   * onMixEnd triggered. Update activeState on for toggleContainer.
   * 
   */
   
  // obtain a reference to your groups container element:
  let toggleContainer = document.querySelector('[data-filter-group="toggles"]');
  let toggleContainerModal = document.querySelector('[data-filter-group="toggles-nav"]');

  function handleToggleFilters() {
      // get a list of all filters active for the group

      // Check if toggleContainer exists before trying to get its filters
      if (toggleContainer) {
          let activeFilters = mixer.getFilterGroupSelectors('toggles'); // e.g: ['.toggles']
          
          if (activeFilters.length == 0 || activeFilters[0].length == 0 ) {
              toggleContainer.classList.remove('filter-group-active');
          } else {
              toggleContainer.classList.add('filter-group-active');
          }
      }
      
      // Check if toggleContainerModal exists before trying to get its filters
      if (toggleContainerModal) {
          let activeFiltersModal = mixer.getFilterGroupSelectors('toggles-nav'); // e.g: ['.toggles']
          
          if (activeFiltersModal.length == 0) {
              toggleContainerModal.classList.remove('filter-group-active');
          } else {
              toggleContainerModal.classList.add('filter-group-active');
          }
      }

  }

  let projectFeed = document.querySelector('.projects-feed');
  let initialFilter = 'all';

  // update initialFilter if hash exists
  let hash = window.currentFilter;
  if (!projectFeed) return;
  if (hash) {
    initialFilter = '.' + hash;

    //set button state
    let activeButtons = document.querySelectorAll('[data-toggle="'+initialFilter+'"');

    activeButtons.forEach(function (button) {
      button.click();
      let parent = button.closest('[data-filter-group]');
      parent.classList.add('filter-group-active');
    });

  }
  window.projectFilter = new projectFilter(projectFeed, initialFilter);



  watchResize();

}

const destroyProjectFilter = () => {

  mixer.destroy();

}

function watchResize() {
  let closeToggle = document.querySelector('button[modal-number="2"]')

  function removeModal() {
    if (!document.body.classList.contains('modal-active')) return
    if (closeToggle.getAttribute('aria-expanded') == "true") {
      closeToggle.click();
    }
  }

  // Debounce
  function debounce(func, time){
    var time = time || 100; // 100 by default if no param
    var timer;
    return function(event){
        if(timer) clearTimeout(timer);
        timer = setTimeout(func, time, event);
    };
  }

  // Listen to the resize event
  window.addEventListener("resize", () => {
    debounce(removeModal());
  }, false);

}

export {setProjectFilter, destroyProjectFilter};